module.exports = __webpack_public_path__ + "static/media/Durga.efe77896.md";